import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import ExternalTxnListPageUI from './ExternalTxnListPageUI.js'

class ExternalTxnListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      bankTxnList: null,
      totalAmount: null,
      totalAmountF1: null,
      drAmountF1Map: {},
      crAmountF1Map: {},
      copyToClipboardText: null,
    }
  }

  render() {
    return (
      <ExternalTxnListPageUI
        context={this.props.context}
        accountNumber={this.props.match.params.accountNumber}
        bankTxnList={this.state.bankTxnList}
        totalAmount={this.state.totalAmount}
        totalAmountF1={this.state.totalAmountF1}
        crAmountF1Map={this.state.crAmountF1Map}
        drAmountF1Map={this.state.drAmountF1Map}
        totals={this.state.totals}
        onRefreshClick={this.onRefreshClick}
        //
        copyToClipboardText={this.state.copyToClipboardText}
        onCopyToClipboard={this.onCopyToClipboard}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getBankTxns(context, this.props.match.params.accountNumber)
  }

  getBankTxns(context, accountNumber) {
    let cacheManager = new CacheManager({
      resource: `/api/su/nodalBankAccounts/${accountNumber}/bankTransactions/external`,
      cacheKey: CacheKeys.ExternalTxns(accountNumber),
      callback: this.getBankTxnsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getBankTxnsCallback = (response) => {
    this.setState({
      bankTxnList: response.transactionList,
      totalAmount: response.totalAmount,
      totalAmountF1: response.totalAmountF1,
      crAmountF1Map: response.crAmountF1Map,
      drAmountF1Map: response.drAmountF1Map,
      totals: response
    })
  }

  onCopyToClipboard = (text, result) => {
    this.setState({ copyToClipboardText: text })
    setTimeout(() => {
      this.setState({ copyToClipboardText: null })
    }, 3000)
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.ExternalTxns(this.props.match.params.accountNumber))
    this.setState({ bankTxnList: null }, () => {
      this.getBankTxns(context, this.props.match.params.accountNumber)
    })
  }
}

export default withRouter(ExternalTxnListPageSF)
